<!--
  -  Copyright (c) Qwoach LLC 2023. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 21/2/2023
  -->

<template>
<div>
	<qw-form :rules="rules" :model="additionalInfoItem" ref="mainForm">
		<FormRow
			title="Collect additional information:"
			tooltip-text="Enable to collect relevant information. <br/><br/>It will be automatically added to the client's profile.<br/><br/>Note: email and name will be collected by default for all new clients."
			tooltip-position="title"/>
		<FormSwitchRow
			:label-min-width="labelMinWidth"
			class="form-title-normal"
			title="Company"
			v-model="additionalInfoItem.collectCompany"
			@change="notifyValueChanged"
		/>
		<FormSwitchRow
			:label-min-width="labelMinWidth"
			class="form-title-normal"
			title="Profession"
			v-model="additionalInfoItem.collectOccupation"
			@change="notifyValueChanged"
		/>
		<FormSwitchRow
			:label-min-width="labelMinWidth"
			class="form-title-normal"
			title="Primary Phone"
			v-model="additionalInfoItem.collectPhone"
			@change="notifyValueChanged"
		/>
		<FormSwitchRow
			:label-min-width="labelMinWidth"
			class="form-title-normal"
			title="Primary Address"
			v-model="additionalInfoItem.collectAddress"
			@change="notifyValueChanged"
		/>
		<FormSwitchRow
			:label-min-width="labelMinWidth"
			tooltip-position="title"
			tooltip-text="If enabled, your clients will be required to check a checkbox to indicate their consent before submitting their assessment. You can configure the text for the consent."
			class="form-title-normal"
			title="Request consent"
			v-model="additionalInfoItem.collectConsent"
			@change="notifyValueChanged"
		/>
		<FormEditorRow
			v-if="additionalInfoItem.collectConsent"
			:label-min-width="labelMinWidth"
			tooltip-position="title"
			tooltip-text="Add your custom text for the consent that will be shown to your clients. <br/><br/>You can also include links to your external resources, like your privacy policy."
			class="form-title-normal"
			title="Consent text"
			prop="consentText"
			v-model="additionalInfoItem.consentText"
			@change="notifyValueChanged"
		/>

	</qw-form>
</div>
</template>

<script>

import BaseVModelView from "@/core/components/BaseVModelView.vue";
import FormSwitchRow from "@/core/components/Form/FormSwitchRow.vue";
import AdditionalInfoItem from "@shared/Profile/AdditionalInfoItem";
import FormRow from "@/core/components/Form/Base/FormRow.vue";
import FormTextRow from "@/core/components/Form/FormTextRow.vue";
import FormEditorRow from "@/core/components/Form/FormEditorRow.vue";

export default {
	name: "CollectInfoSettingsView",
	components: {FormEditorRow, FormTextRow, FormRow, FormSwitchRow},
	extends: BaseVModelView,

	props: {
		value: {AdditionalInfoItem, require: true},
	},

	data() {
		return {
			labelMinWidth: 150,
			rules: {
				consentText: [
					{
						required: true,
						whitespace: false,
						message: "Please provide consent text or switch off 'Request consent' above",
						trigger: 'validate'
					},
				],
			}
		}
	},


	computed: {
		additionalInfoItem: {
			get: function (){
				return this.valueData
			},
			set: function (value){
				this.valueData = value
				this.notifyValueChanged()
			}

		}
	},

}
</script>

<style lang="scss">

</style>
